import {debounceEvent, detectMobile, detectTablet} from '../../../js/utils';

export default class Navigation {
  constructor() {
    this.navigation = undefined;
  }

  init() {
    this.isMobile = detectMobile();
    this.isTablet = detectTablet();
    this.navigation = document.querySelector('.js-swa-main-navigation');

    if (!this.navigation) {
      return;
    }

    if (!this.isMobile) {
      if (this.navigation.querySelector('.swa-main-navigation--level1')) {
        this.navigation
          .querySelector('.swa-main-navigation--level1')
          .classList.remove('swa-hidden');
      }
    } else {
      this.handleMenuItemsMarginMobile();
    }

    this.addMobileButtonsListeners();
    this.addWindowResizeListener();
    this.addDesktopMainMenuListeners();
    this.extendClickableAreaMobileTablet();
  }

  addMobileButtonsListeners() {
    let mobileMenuButton = document.querySelector('.js-mobile-menu-button');
    let menuNext = this.navigation.querySelectorAll('.js-main-navigation-next');
    let menuBack = this.navigation.querySelectorAll('.js-main-navigation-back');
    let menuClose = this.navigation.querySelector('.js-main-navigation-close');

    const cartLayer = document.querySelector('.swa-header__cart-flyout');
    const flyoutContainer = document.querySelector('.swa-header__flyout-container');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');
    const logoMobileTransparent = document.querySelector('.swa-header__compressed-logo-transparent');
    const headerOverlay = document.querySelector('.swa-header__overlay');
    const searchIcon = document.querySelector('.swa-header__search-icon');

    mobileMenuButton.addEventListener('click', () => {
      const body = document.querySelector('body');

      this.navigation.classList.remove('swa-hidden');
      this.navigation.classList.add('swa-main-navigation--sm-opened');
      flyoutContainer.classList.add('swa-hidden');
      this.navigation.classList.remove('swa-hidden--sm-down', 'swa-close-animation');
      menuClose.parentNode.classList.remove('swa-back-animation');

      if (headerOverlay && flyoutContainer.classList.contains('swa-header__flyout-container--search')) {
        headerOverlay.classList.remove('swa-active');
      }
      if (searchIcon && searchIcon.classList.contains('swa-active')) {
        searchIcon.classList.remove('swa-active');
      }
      flyoutContainer.classList.remove('swa-header__flyout-container--search');
      flyoutContainer.classList.remove('fade-in');
      cartLayer.classList.add('swa-hidden-cart');

      body.style.overflowY = 'auto';

      // For transparent case - the big logo on Mobile needs to be hidden when the navigation is open
      if (transparentHeader && logoMobileTransparent) {
        logoMobileTransparent.classList.add('swa-hidden');
      }

      setTimeout(
        function () {
          let topLevelNavigation = this.navigation.querySelector('.swa-main-navigation--level1');
          topLevelNavigation.classList.remove('swa-hidden');
          setTimeout(function () {
            topLevelNavigation.classList.add('swa-menu-animated');
          }, 0);
        }.bind(this),
        0
      );
    });

    menuNext.forEach(item => {
      item.addEventListener('click', event => {
        let subMenu = item.parentNode.querySelector('nav');
        const secondLevelContainer = subMenu.querySelector('.swa-main-navigation__level2');
        if (secondLevelContainer) {
          let secondLevelElements = subMenu.querySelectorAll('.swa-main-navigation__level2 > .swa-main-navigation__menu-item:not(.swa-hidden-lg)');
          const secondLevelFlyout = secondLevelContainer.querySelector('.swa-main-navigation-flyout-wrapper');
          let secondLevelElementsColsLength = 0;

          // sort the 2nd level column menu items by data-col attribute
          let secondLevelElementsSorted = [].slice.call(secondLevelElements).sort(function (a, b) {
            return a.dataset.col === b.dataset.col ? 0 : (a.dataset.col > b.dataset.col ? 1 : -1);
          });

          secondLevelElementsSorted.forEach(function (elem) {
            // get the columns length of the current menu item by calculating the maximum data-col value
            if (elem.dataset.col > secondLevelElementsColsLength) {
              secondLevelElementsColsLength = elem.dataset.col;
            }
            // append the sorted items to the 2nd level container
            secondLevelContainer.appendChild(elem);
          });

          if (secondLevelFlyout) {
            secondLevelContainer.appendChild(secondLevelFlyout);
          }

          //add the gray background class to the elements on the last column
          secondLevelElements.forEach(item => {
            if (item.dataset.col === secondLevelElementsColsLength && secondLevelElementsColsLength > 1) {
              item.classList.add('swa-main-navigation__menu-item--gray');
            }
          });
        }

        const mobileMenuTopSectionContainer = this.navigation.querySelector(
          '.swa-main-navigation__mobile-top-section-parent-category'
        );
        const mobileMenuTopSectionCategory = this.navigation.querySelector(
          '.swa-main-navigation__mobile-top-section .swa-main-navigation__mobile-top-section-parent-category h3'
        );
        mobileMenuTopSectionContainer.classList.add('swa-main-navigation__mobile-top-section-parent-category-animation--r2l');
        const currentCategoryContainer = item.parentElement.querySelector(
          '.swa-main-navigation__menu-item__link'
        );
        const currentCategoryText = currentCategoryContainer.querySelector('a') ? currentCategoryContainer.querySelector('a') : currentCategoryContainer.querySelector('span');
        if (currentCategoryText) {
          setTimeout(() => mobileMenuTopSectionContainer.classList.remove('swa-main-navigation__mobile-top-section-parent-category-animation--r2l'), 10);
          mobileMenuTopSectionCategory.textContent = currentCategoryText.textContent;
        }
        subMenu.classList.remove('swa-hidden');
        setTimeout(function () {
          subMenu.classList.add('swa-menu-animated');
        }, 0);
      });
    });

    menuBack.forEach(item => {
      item.addEventListener('click', event => {
        let containerMenu = item.closest('nav');
        const mobileMenuTopSectionContainer = this.navigation.querySelector(
          '.swa-main-navigation__mobile-top-section-parent-category'
        );

        mobileMenuTopSectionContainer.classList.add('swa-main-navigation__mobile-top-section-parent-category-animation--l2r');
        const mobileMenuTopSectionCategory = this.navigation.querySelector(
          '.swa-main-navigation__mobile-top-section .swa-main-navigation__mobile-top-section-parent-category h3'
        );
        const containerMenuParentLinkElement = containerMenu.parentElement.querySelector(
          '.swa-main-navigation__menu-item__link a'
        );
        const containerMenuClassList = containerMenu.classList;
        let currentLevel;
        containerMenuClassList.forEach(element => {
          if (element.includes('swa-main-navigation--level')) {
            currentLevel = element.substr(element.length - 1);
          }
        });
        if (currentLevel) {
          if (currentLevel <= 2) {
            setTimeout(() => mobileMenuTopSectionContainer.classList.remove('swa-main-navigation__mobile-top-section-parent-category-animation--l2r'), 10);

            mobileMenuTopSectionCategory.textContent = '';
          } else if (containerMenuParentLinkElement) {
            const navHigherLevel = containerMenu.closest(
              '.swa-main-navigation--level' + (currentLevel - 1)
            );
            const higherLevelParentCategoryContainer = navHigherLevel.parentElement.querySelector(
              '.swa-main-navigation__menu-item__link'
            );
            const higherLevelParentCategoryText = higherLevelParentCategoryContainer.querySelector('a') ? higherLevelParentCategoryContainer.querySelector('a') :
              higherLevelParentCategoryContainer.querySelector('span');
            setTimeout(() => mobileMenuTopSectionContainer.classList.remove('swa-main-navigation__mobile-top-section-parent-category-animation--l2r'), 10);
            mobileMenuTopSectionCategory.textContent = higherLevelParentCategoryText.textContent;
          }
        } else {
          setTimeout(() => mobileMenuTopSectionContainer.classList.remove('swa-main-navigation__mobile-top-section-parent-category-animation--l2r'), 10);
          mobileMenuTopSectionCategory.textContent = '';
        }
        containerMenu.classList.remove('swa-menu-animated');
        setTimeout(function () {
          containerMenu.classList.add('swa-hidden');
        }, 300);
      });
    });
    if (menuClose) {
      menuClose.addEventListener('click', event => {
        this.navigation.classList.remove('swa-main-navigation--sm-opened');
        menuClose.parentNode.classList.add('swa-back-animation');
        this.navigation.classList.add('swa-close-animation');
        document.querySelector('.js-swa-main-navigation .swa-header__icons').classList.add('swa-hidden--sm-down');

        // For transparent case - the big logo on Mobile needs to be active when the navigation is closed
        if (transparentHeader && logoMobileTransparent) {
          logoMobileTransparent.classList.remove('swa-hidden');
          this.hideHeaderLogoSmall();
        }

        this.navigation.querySelectorAll('nav').forEach(navMenu => {
          navMenu.classList.remove('swa-menu-animated');
        });

        const mobileMenuTopSectionCategory = this.navigation.querySelector(
          '.swa-main-navigation__mobile-top-section .swa-main-navigation__mobile-top-section-parent-category h3'
        );
        mobileMenuTopSectionCategory.textContent = '';
      });
    }
  }

  showHeaderLogoSmall() {
    const header = document.querySelector('.swa-header');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');
    if (transparentHeader) {
      header.classList.add('swa-header--sticky');
      header.classList.add('swa-header--solid');
      header.classList.remove('swa-header--transparent');

      const logoImage = document.querySelector(
        '.swa-header__compressed .swa-link__image--logo-mobile--default'
      );
      if (logoImage) {
        logoImage.src = logoImage.dataset.hover;
      }
    }
  }

  hideHeaderLogoSmall() {
    const header = document.querySelector('.swa-header');

    const mainNavigationHeight = 39;
    const stickyHeaderPositionTriggerSmall = 50 - mainNavigationHeight;
    let updatedScrollPosition = 0;

    updatedScrollPosition = window.pageYOffset;

    if (updatedScrollPosition < stickyHeaderPositionTriggerSmall) {
      header.classList.remove('swa-header--sticky');
      header.classList.remove('swa-header--solid');
      header.classList.add('swa-header--transparent');

      //If the small logo header transparent variation on mobile/tablet, use the white logo after closing the navigation flyout
      const logoImageSmallMobile = document.querySelector('.swa-header__compressed-logo--show');
      const logoImage = document.querySelector('.swa-header__compressed .swa-link__image--logo-mobile--default');

      if (logoImageSmallMobile && !header.classList.contains('swa-header--transparent-light')) {
        logoImage.src = '/images/icons/swa-brandlogo-icon-big-white.svg';
      }
    }
  }

  addWindowResizeListener() {
    window.addEventListener(
      'resize',
      debounceEvent(() => {
        let currentIsMobile = detectMobile();
        let currentIsTablet = detectTablet();

        if (this.isMobile != currentIsMobile && this.isMobile) {
          this.navigation
            .querySelector('.swa-main-navigation--level1')
            .classList.remove('swa-hidden');
          this.isMobile = !this.isMobile;
          this.addDesktopMainMenuListeners();
        } else if (this.isTablet !== currentIsTablet || this.isMobile !== currentIsMobile) {
          this.navigation.querySelector('.swa-main-navigation--level1').classList.remove('swa-hidden');
          this.isMobile = !this.isMobile;
          this.handleMenuItemsMarginMobile();
          this.addMobileButtonsListeners();
          this.extendClickableAreaMobileTablet();
        } else if (this.isMobile != currentIsMobile && !this.isMobile) {
          //when desktop resolution kicks in on a device, handle the exception
          this.handleDesktopLayoutOnDeviceException();
          this.navigation.querySelector('.swa-main-navigation--level1').classList.add('swa-hidden');
          this.isMobile = !this.isMobile;
          this.handleMenuItemsMarginMobile();
          this.addMobileButtonsListeners();
          this.extendClickableAreaMobileTablet();
        }
      }, 250)
    );
  }

  calculatePadding() {
    const mainMenuItems = this.navigation.querySelectorAll(
      '.swa-main-navigation__level1>.swa-main-navigation__menu-item'
    );
    const mainMenuIcons = this.navigation.querySelector('.swa-header__icons');
    const mainMenuIconsSticky = this.navigation.querySelector('.swa-header__sticky-icons');
    const mainMenuItemsNo = mainMenuItems.length;

    let mainMenuItemWidthSum;
    let finalPaddingMenuItem;

    const minPadding = 30;
    const maxPadding = 60;

    let navigationContainerWidthString = window
      .getComputedStyle(this.navigation, null)
      .getPropertyValue('width');
    let navigationContainerWidth = parseInt(
      navigationContainerWidthString.substring(0, navigationContainerWidthString.length - 2),
      10
    );

    let navigationIconsWidthString;
    let navigationIconsWidth;
    let finalMarginLeftMenuItem;
    let isDesktopMid = (window.screen.width >= 1025 && window.screen.width <= 1279);

    setTimeout(() => {
      mainMenuItemWidthSum = 0;

      let mainMenuIconsDisplay = window
        .getComputedStyle(mainMenuIcons, null)
        .getPropertyValue('display');
      let mainMenuIconsStickyDisplay = window
        .getComputedStyle(mainMenuIconsSticky, null)
        .getPropertyValue('display');

      if (mainMenuIconsDisplay !== 'none') {
        navigationIconsWidthString = window
          .getComputedStyle(mainMenuIcons, null)
          .getPropertyValue('width');
      } else if (mainMenuIconsStickyDisplay !== 'none') {
        navigationIconsWidthString = window
          .getComputedStyle(mainMenuIconsSticky, null)
          .getPropertyValue('width');
      }

      if (navigationIconsWidthString) {
        navigationIconsWidth = parseInt(
          navigationIconsWidthString.substring(0, navigationIconsWidthString.length - 2),
          10
        );
      }

      mainMenuItems.forEach(item => {
        const mainMenuItemText = item.getElementsByTagName('a')[0];
        if (mainMenuItemText) {
          mainMenuItemWidthSum += mainMenuItemText.getBoundingClientRect().width;
        }
      });

      navigationContainerWidthString = window
        .getComputedStyle(this.navigation, null)
        .getPropertyValue('width');
      navigationContainerWidth = parseInt(
        navigationContainerWidthString.substring(0, navigationContainerWidthString.length - 2),
        10
      );

      const mainMenuItemsSpaceLeft =
        navigationContainerWidth - navigationIconsWidth - mainMenuItemWidthSum;
      const paddingBetweenItems = mainMenuItemsSpaceLeft / (mainMenuItemsNo - 1);

      if (paddingBetweenItems < maxPadding && paddingBetweenItems > minPadding) {
        finalPaddingMenuItem = paddingBetweenItems;
      } else if (paddingBetweenItems >= maxPadding) {
        finalPaddingMenuItem = maxPadding;
      } else if (paddingBetweenItems <= minPadding) {
        finalPaddingMenuItem = minPadding;
      }

      finalPaddingMenuItem = isDesktopMid ? ((window.screen.width * ((1.2/1025)*20)).toFixed(2)) : finalPaddingMenuItem;
      finalMarginLeftMenuItem = isDesktopMid ? 20 : finalPaddingMenuItem;

      mainMenuItems.forEach((item, i, arr) => {
        if (arr[0] === item) {
          item.setAttribute(
            'style',
            'padding-left:' +
            finalPaddingMenuItem / 2 / 10 +
            'rem' +
            '; padding-right:' +
            finalPaddingMenuItem / 2 / 10 +
            'rem' +
            '; margin-left: -' +
            finalMarginLeftMenuItem / 2 / 10 +
            'rem'
          );
        } else if (arr[arr.length - 1] === item) {
          item.setAttribute(
            'style',
            'padding-left:' +
            finalPaddingMenuItem / 2 / 10 +
            'rem' +
            '; padding-right:' +
            finalPaddingMenuItem / 2 / 10 +
            'rem' +
            '; margin-right: -' +
            finalPaddingMenuItem / 2 / 10 +
            'rem'
          );
        } else {
          item.setAttribute(
            'style',
            'padding-left:' + finalPaddingMenuItem / 2 / 10 + 'rem' + '; padding-right:' + finalPaddingMenuItem / 2 / 10 + 'rem'
          );
        }
      });
    }, 0);
  }

  setPaddingOnMenuItems() {
    let navigationContainerWidthString = window
      .getComputedStyle(this.navigation, null)
      .getPropertyValue('width');
    let navigationContainerWidth = parseInt(
      navigationContainerWidthString.substring(0, navigationContainerWidthString.length - 2),
      10
    );

    const initialNavigationContainerWidth = navigationContainerWidth;

    let needPaddingChange = true;

    window.addEventListener('scroll', () => {
      if (!this.isMobile) {
        navigationContainerWidthString = window
          .getComputedStyle(this.navigation, null)
          .getPropertyValue('width');
        navigationContainerWidth = parseInt(
          navigationContainerWidthString.substring(0, navigationContainerWidthString.length - 2),
          10
        );
        if (window.pageYOffset === 0) {
          this.calculatePadding();
        }
        if (navigationContainerWidth !== initialNavigationContainerWidth && needPaddingChange) {
          this.calculatePadding();
          needPaddingChange = !needPaddingChange;
        } else if (
          navigationContainerWidth === initialNavigationContainerWidth &&
          !needPaddingChange
        ) {
          this.calculatePadding();
          needPaddingChange = !needPaddingChange;
        }
      }
    });
    this.calculatePadding();
  }

  handleDesktopLayoutOnDeviceException() {
    let mainMenuItems = this.navigation.querySelectorAll(
      '.swa-main-navigation__level1>.swa-main-navigation__menu-item'
    );
    const flyoutContainer = document.querySelector('.swa-header__flyout-container');
    const header = document.querySelector('.swa-header');
    const headerOverlay = header.querySelector('.swa-header__overlay');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');

    let stickyHeaderPositionTriggerLarge;

    const mainNavigationHeight = 39;
    if (transparentHeader) {
      stickyHeaderPositionTriggerLarge = 50;
    } else {
      stickyHeaderPositionTriggerLarge = document.querySelector('header').offsetHeight - mainNavigationHeight;
    }

    mainMenuItems.forEach(item => {
      if (item.classList.contains('swa-active')) {
        item.classList.remove('swa-active');
        if (flyoutContainer.classList.contains('swa-hidden')) {
          headerOverlay && headerOverlay.classList.remove('swa-active');
        }

        let updatedScrollPosition = 0;
        let openedMenu = document.querySelector('.swa-main-navigation__level1>.swa-active') ? true : false;

        updatedScrollPosition = window.pageYOffset;

        if (updatedScrollPosition > stickyHeaderPositionTriggerLarge && !openedMenu) {
          const middleSlot = header.querySelector('.swa-header__middle-slot');

          middleSlot.classList.remove('swa-header__middle-slot--transition');
          header.classList.add('swa-header--sticky');
          this.calculatePadding();
        }
      }

      let itemNav = item.querySelector('nav');
      if (itemNav) {
        let itemNavList = itemNav.querySelector('.swa-main-navigation__level2');

        itemNav.classList.remove('swa-active');
        itemNav.classList.add('swa-hidden');

        itemNavList.classList.remove('swa-fade-in');
        // IE needs this extra class for having the same behaviour as the other browsers
        itemNavList.classList.remove('swa-fade-in-no-animation');
        itemNavList.classList.add('swa-hidden-lg');
      }
      item.replaceWith(item.cloneNode(true));
    });
  };

  //apply styling to each menu item
  handleMenuItemsLayout(item) {
    let mainMenuItems = this.navigation.querySelectorAll(
      '.swa-main-navigation__level1>.swa-main-navigation__menu-item'
    );
    const cartLayer = document.querySelector('.swa-header__cart-flyout');
    const flyoutContainer = document.querySelector('.swa-header__flyout-container');
    const cartIconUnderlined = document.querySelector('.swa-header__cart-icon');
    const cartIconUnderlinedSticky = document.querySelector('.swa-header__sticky-cart-icon');
    const searchIconUnderlined = document.querySelector('.swa-header__search-icon');
    const searchIconUnderlinedSticky = document.querySelector('.swa-header__sticky-search-icon');
    const header = document.querySelector('.swa-header');
    const headerOverlay = header.querySelector('.swa-header__overlay');
    const secondLevelNav = item.querySelector('.swa-main-navigation--level2');
    const secondLevelNavList = item.querySelector('.swa-main-navigation__level2');

    item.querySelectorAll('nav').forEach(nav => {
      nav.classList.remove('swa-hidden');
    });

    if (secondLevelNav) {
      flyoutContainer.classList.add('swa-hidden');
      const body = document.querySelector('body');
      body.style.overflowY = 'auto';
      cartLayer.classList.add('swa-hidden-cart');
      flyoutContainer.classList.remove('fade-in');
      flyoutContainer.classList.remove('fade-in-no-animation');
      flyoutContainer.classList.remove('swa-header__flyout-container--search');

      if (cartIconUnderlined) {
        cartIconUnderlined.classList.remove('swa-active');
        headerOverlay && headerOverlay.classList.remove('swa-active');
      }
      searchIconUnderlined.classList.remove('swa-active');
      if (cartIconUnderlinedSticky) {
        cartIconUnderlinedSticky.classList.remove('swa-active');
      }
      searchIconUnderlinedSticky.classList.remove('swa-active');
      if (header.classList.contains('swa-header--transparent-solid-focus')) {
        header.classList.remove('swa-header--transparent-solid-focus');
      }
    }

    this.showActiveMenuDesktop(mainMenuItems, item, headerOverlay);

    let secondLevelElements = item.querySelectorAll(
      '.swa-main-navigation__level2 > .swa-main-navigation__menu-item'
    );
    let currentRow = 0;

    let firstCol = [];
    let secondCol = [];
    let thirdCol = [];
    let fourthCol = [];

    let navTeaser = item.querySelector(
      '.swa-main-navigation__level2>.swa-main-navigation-flyout-wrapper'
    );

    secondLevelElements.forEach(secondNav => {
      let currentCol = secondNav.dataset.col;
      if (currentCol) {
        if (currentCol === 1) {
          currentRow++;
        }

        switch (currentCol.toString()) {
        case '1':
          firstCol.push(secondNav);
          break;
        case '2':
          secondCol.push(secondNav);
          break;
        case '3':
          thirdCol.push(secondNav);
          break;
        case '4':
          fourthCol.push(secondNav);
          break;
        default:
          firstCol.push(secondNav);
        }
      }
    });

    setTimeout(() => {
      let colsArray = [];

      if (firstCol.length > 0) {
        colsArray.push(firstCol);
      }
      if (secondCol.length > 0) {
        colsArray.push(secondCol);
      }
      if (thirdCol.length > 0) {
        colsArray.push(thirdCol);
      }
      if (fourthCol.length > 0) {
        colsArray.push(fourthCol);
      }

      let minHeightNavSecondLevel = 0;

      // menuTeaser height + spacing of the navigation level 2
      if (navTeaser) {
        minHeightNavSecondLevel = navTeaser.getBoundingClientRect().height + 50;
      }

      let maxListHeight = 0;

      if (colsArray.length > 1) {
        if (secondLevelNavList.querySelectorAll('.swa-main-navigation-gray-column').length === 0) {
          const grayCol = document.createElement('div');
          grayCol.classList.add('swa-main-navigation-gray-column');
          grayCol.classList.add('swa-main-navigation-gray-column__' + colsArray.length + '-col');
          secondLevelNavList.appendChild(grayCol);
          colsArray[colsArray.length - 1].forEach(item => {
            item.classList.add('swa-main-navigation__level2-last-col');
          });
        }
      }

      colsArray.forEach(item => {
        let marginTopElement = 0;
        let listHeight = 0;

        for (let i = 0; i < item.length; i++) {
          listHeight = listHeight + item[i].getBoundingClientRect().height + 10;

          if (listHeight > maxListHeight) {
            maxListHeight = listHeight;
          }

          if (minHeightNavSecondLevel) {
            if (maxListHeight < minHeightNavSecondLevel) {
              item[0].parentElement.setAttribute(
                'style',
                'height: ' + minHeightNavSecondLevel + 'px'
              );
            } else {
              item[0].parentElement.setAttribute('style', 'height: ' + maxListHeight + 'px');
            }
          } else if (item[0].parentElement.getBoundingClientRect().height < listHeight) {
            item[0].parentElement.setAttribute('style', 'height: ' + listHeight + 'px');
          }
          if (i !== 0) {
            marginTopElement =
              marginTopElement + item[i - 1].getBoundingClientRect().height + 10;
          }
          item[i].setAttribute(
            'style',
            '-ms-grid-row: ' +
            currentRow +
            '; -ms-grid-column: ' +
            item[i].dataset.col +
            '; grid-row: ' +
            currentRow +
            '; grid-column: ' +
            item[i].dataset.col +
            '; margin-top: ' +
            marginTopElement +
            'px'
          );
        }
      });
    }, 300);
  }

  handleMenuItemsMarginMobile() {
    this.navigation
      .querySelectorAll('.swa-main-navigation__level1>.swa-main-navigation__menu-item')
      .forEach(element => {
        element.style.margin = '0';
        element.style.padding = '0';
        element.style.paddingLeft = '3rem';
      });
    this.navigation
      .querySelectorAll('.swa-main-navigation__level2>.swa-main-navigation__menu-item')
      .forEach(element => {
        element.style.gridColumn = 'none';
        element.style.marginTop = '0';
      });
  }

  addDesktopMainMenuListeners() {
    let mainMenuItems = this.navigation.querySelectorAll(
      '.swa-main-navigation__level1>.swa-main-navigation__menu-item'
    );
    const flyoutContainer = document.querySelector('.swa-header__flyout-container');
    const header = document.querySelector('.swa-header');
    const headerOverlay = header.querySelector('.swa-header__overlay');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');

    let stickyHeaderPositionTriggerLarge;

    const mainNavigationHeight = 39;
    if (transparentHeader) {
      stickyHeaderPositionTriggerLarge = 50;
    } else {
      stickyHeaderPositionTriggerLarge = document.querySelector('header').offsetHeight - mainNavigationHeight;
    }

    if (!this.isMobile) {
      this.setPaddingOnMenuItems();
    }

    mainMenuItems.forEach(item => {
      item.addEventListener('mouseleave', event => {
        if (item.classList.contains('swa-active')) {
          item.classList.remove('swa-active');
          if (flyoutContainer.classList.contains('swa-hidden')) {
            headerOverlay && headerOverlay.classList.remove('swa-active');
          }

          let updatedScrollPosition = 0;
          let openedMenu = document.querySelector('.swa-main-navigation__level1>.swa-active') ? true : false;

          updatedScrollPosition = window.pageYOffset;

          if (updatedScrollPosition > stickyHeaderPositionTriggerLarge && !openedMenu) {
            const middleSlot = header.querySelector('.swa-header__middle-slot');

            middleSlot.classList.remove('swa-header__middle-slot--transition');
            header.classList.add('swa-header--sticky');
            this.calculatePadding();
          }
        }

        if (!this.isMobile) {
          let itemNav = item.querySelector('nav');
          if (itemNav) {
            let itemNavList = itemNav.querySelector('.swa-main-navigation__level2');

            itemNav.classList.remove('swa-active');
            itemNav.classList.add('swa-hidden');

            itemNavList.classList.remove('swa-fade-in');
            // IE needs this extra class for having the same behaviour as the other browsers
            itemNavList.classList.remove('swa-fade-in-no-animation');
            itemNavList.classList.add('swa-hidden-lg');
          }
        }
      });

      item.addEventListener('mouseenter', event => {
        //if not mobile apply desktop styling to each item
        if (!this.isMobile) {
          this.handleMenuItemsLayout(item);
        }
      });
    });
  }

  showActiveMenuDesktop(mainMenuItems, navigationNode, headerOverlay) {
    mainMenuItems.forEach(item => {
      if (item.classList.contains('swa-active')) {
        item.classList.remove('swa-active');
      }
    });

    // function that returns all the siblings of an element by filtering all the children of his parent
    const getSiblings = elem => {
      // convert HTMLCollection to array
      let childrenArray = [...elem.parentNode.children];

      return childrenArray.filter(sibling => {
        return sibling !== elem;
      });
    };

    const navigationNodeSiblings = getSiblings(navigationNode);

    navigationNodeSiblings.forEach(sibling => {
      let siblingNav = sibling.querySelector('nav');
      if (siblingNav) {
        siblingNav.classList.remove('swa-active');
        siblingNav.classList.add('swa-hidden');
      }
    });

    if (!navigationNode.classList.contains('swa-active')) {
      navigationNode.classList.add('swa-active');
      let subMenu = navigationNode.querySelector('.swa-main-navigation--level2');
      subMenu && headerOverlay && headerOverlay.classList.add('swa-active');

      let secondNavMenu = navigationNode.querySelector('nav');
      let openedMenu = this.navigation.querySelector('.swa-main-navigation--level2.swa-active');
      if (secondNavMenu) {
        secondNavMenu.classList.add('swa-active');
        headerOverlay && headerOverlay.classList.add('swa-active');
        setTimeout(
          function () {
            secondNavMenu
              .querySelector('.swa-main-navigation__level2')
              .classList.remove('swa-hidden-lg');
            secondNavMenu
              .querySelector('.swa-main-navigation__level2')
              .classList.add('swa-fade-in');
            // IE needs this extra class for having the same behaviour as the other browsers
            secondNavMenu
              .querySelector('.swa-main-navigation__level2')
              .classList.add('swa-fade-in-no-animation');
            if (openedMenu && openedMenu != secondNavMenu) {
              this.closeMenuDesktop(headerOverlay, openedMenu);
            }
          }.bind(this),
          300
        );
      } else {
        /* current menu item doesn't have submenu */
        this.closeMenuDesktop(headerOverlay);
      }
    }
  }

  closeMenuDesktop(headerOverlay, activeMenu) {
    let openedMenu = activeMenu ?
      activeMenu :
      this.navigation.querySelector('.swa-main-navigation--level2.swa-active');

    if (openedMenu) {
      openedMenu.classList.remove('swa-active');
      openedMenu.querySelector('.swa-main-navigation__level2').classList.remove('swa-fade-in');
      openedMenu
        .querySelector('.swa-main-navigation__level2')
        .classList.remove('swa-fade-in-no-animation');
      openedMenu.querySelector('.swa-main-navigation__level2').classList.add('swa-hidden-lg');
      setTimeout(function () {
        openedMenu.classList.add('swa-hidden');
      }, 300);
    }
  }

  extendClickableAreaMobileTablet() {
    const navItemTitles = document.querySelectorAll('.swa-main-navigation__menu-item__link a');
    navItemTitles.forEach(navItemTitle => {
      navItemTitle.addEventListener('click', event => {
        const nextArrowBtn = navItemTitle
          .closest('.swa-main-navigation__menu-item')
          .querySelector('.swa-main-navigation__mobile-next');
        if (detectMobile() || detectTablet()) {
          if (nextArrowBtn) {
            event.preventDefault();
          } else {
            return true;
          }
        }
      });
    });
  }
}

const nav = new Navigation();

if (
  document.querySelector('.js-swa-main-navigation') &&
  document.querySelector('html[class^="js-patternlab"]')
) {
  window.onload = () => {
    nav.init();
  };
}
